
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M0.710011 1.82998C0.320011 2.21998 0.320011 2.84998 0.710011 3.23998L4.39001 6.91998L6.60001 11.58L5.25001 14.03C5.06001 14.36 4.97001 14.76 5.01001 15.18C5.11001 16.24 6.07001 17 7.13001 17H14.46L15.84 18.38C15.34 18.74 15.01 19.33 15.01 20C15.01 21.1 15.9 22 17 22C17.67 22 18.26 21.67 18.62 21.16L20.75 23.29C21.14 23.68 21.77 23.68 22.16 23.29C22.55 22.9 22.55 22.27 22.16 21.88L2.12001 1.82998C1.73001 1.43998 1.10001 1.43998 0.710011 1.82998ZM7.00001 15L8.10001 13H10.46L12.46 15H7.00001ZM16.05 12.94C16.59 12.8 17.04 12.45 17.3 11.97L20.88 5.47998C21.25 4.81998 20.76 3.99998 20 3.99998H7.12001L16.05 12.94ZM7.00001 18C5.90001 18 5.01001 18.9 5.01001 20C5.01001 21.1 5.90001 22 7.00001 22C8.10001 22 9.00001 21.1 9.00001 20C9.00001 18.9 8.10001 18 7.00001 18Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-remove-shopping-cart`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconRemoveShoppingCart

    ```js
    <b-new-b-icon-remove-shopping-cart />
    ```
</docs>


